/** @jsx jsx */
import React from "react";
import { jsx, css } from "@emotion/core";
interface Props extends Omit<React.SVGProps<SVGSVGElement>, "css"> {
  weight?: "thin" | "normal";
}
export const IconClipboard = React.forwardRef<SVGSVGElement, Props>(
  (
    { fill = "none", stroke = "currentColor", weight = "normal", ...props },
    ref,
  ) => (
    <svg
      viewBox="0 0 20 26"
      ref={ref}
      css={css`
        * {
          vector-effect: non-scaling-stroke;
        }
        overflow: visible;
        height: 26px;
      `}
      {...props}
    >
      <g fill={fill} fillRule="evenodd">
        <path
          stroke={stroke}
          strokeWidth={weight === "normal" ? 1.5 : 1}
          d="M13 4.273h3.273c1.205 0 2.182.977 2.182 2.182v16.363A2.182 2.182 0 0 1 16.273 25H3.182A2.182 2.182 0 0 1 1 22.818V6.455c0-1.205.977-2.182 2.182-2.182h3.273"
        />
        <path
          fill="currentColor"
          d="M9.727 1a3.273 3.273 0 0 1 3.267 3.08l.006.193h1.09v3.272H5.365V4.273h1.09A3.273 3.273 0 0 1 9.728 1zm0 2.182a1.09 1.09 0 1 0 0 2.182 1.09 1.09 0 0 0 0-2.182z"
        />
        <path
          stroke={stroke}
          strokeLinejoin="round"
          strokeWidth={weight === "normal" ? 1.5 : 1}
          d="M5.364 7.545V4.273h1.09a3.273 3.273 0 0 1 6.54-.193l.006.193h1.09v3.272H5.365z"
        />
        <path
          stroke={stroke}
          strokeLinecap="round"
          strokeWidth={weight === "normal" ? 1.5 : 1}
          d="M4.818 11.364h9.818m-9.818 3.818h9.818M4.818 19h5.455"
        />
      </g>
    </svg>
  ),
);
